<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>lblContactCustomer</h4>
    <button type="button" aria-label="Close" class="close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="contactCustomer">
      <div class="col-6">
        <div class="af-form-group">
          <label translate>lblTo</label>
          <div class="lbl-info" >
            <input type="text" [value]="contactCustomer.customerName" readonly class="form-control">
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="af-form-group">
          <label translate>lblPhoneNumber</label>
          <div class="lbl-info">
            <input type="text" [value]="contactCustomer.mobileNo" readonly class="form-control">
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="af-form-group">
          <label translate>lblContent</label>
          <textarea class="h-100px form-control"></textarea>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer">
      <button type="button" (click)="modal.dismiss('Cross click')" class="add-button btn btn-primary btn-lg mr-3">Save</button>
      <button type="button" (click)="modal.dismiss('Cross click')" class="add-button btn btn-secondary btn-lg">Cancel</button>
  </div>
</ng-template>
<div style="font-size: large;text-align: center;" class="mr-5 text-danger fa-lg mt-2 mb-3" *ngIf="customerMessage != null">
  {{customerMessage}}
</div>
<div class="ctm-tab custom-card card-accord">
  <div class="scrollbar longtab">
    <ngb-accordion #acc="ngbAccordion"  (panelChange)="changeTitle($event, acc)" activeIds="customerPanal"  class="main overflow-none-card">
      <ngb-panel id="Payer" *ngIf="!hidePayerAndDriver">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left py-1-5"
                    aria-label="Center Align">
              lblPayer

              <span  *ngIf="customerDetails && customerDetails.customerPayer"
                    class="text-capitalize fs-16px flmid clr666">
                    <span class="mx-3">-</span>
                    {{customerDetails.customerPayer.customerNo}} -
                    {{customerDetails.customerPayer.customerName}}
                <span class="clrbluebright clrhoverthemegrey flmid" (click)="open(content,customerDetails.customerPayer); $event.stopPropagation()">
                  <em class="clrbluebright clrhoverthemegrey fas fa-phone-volume fs-16px fa-lg mr-2 ml-3"></em>
                  <span class="clrbluebright clrhoverthemegrey">+{{customerDetails.customerPayer.dialCode}}-{{customerDetails.customerPayer.mobileNo}}</span>
                </span>
              </span>
              <div class="ml-auto">
                    <button *ngIf="customerDetails && customerDetails.customerPayer" type="button" (click)="isEditMethod('Payer',true)"
                        class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                        lblEdit
                      </button>
                    <button *ngIf="customerDetails && customerDetails.customerPayer" type="button" (click)="viewCustomer(customerDetails.customerPayer)"
                    class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                    lblViewCustomer
                  </button>
                  <button *ngIf="customerDetails && customerDetails.customerPayer" type="button" (click)="DeleteRelation('Payer',customerDetails.customerPayer)"
                        class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                        lblDelete
                  </button>
                      
                <ng-container *ngIf="!acc.activeIds.includes('payer')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
                </ng-container>
                <ng-container *ngIf="acc.activeIds.includes('payer')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
                </ng-container>
              </div>
            </button>

          </div>
        </ng-template>
        <ng-template ngbPanelContent>

          <div *ngIf="editCustomerPayerForm">
            <form [formGroup]="editCustomerPayerForm" (ngSubmit)="onSaveCustomer('Payer',editCustomerPayerForm.value.customerId)">
              <div class="form-row">
                <div class="col-3 af-form-group d-flex align-content-between">
                  <div class="custom-control custom-checkbox mt-25">
                    <input class="custom-control-input" type="checkbox" formControlName="isCompany" (change)="changeCustomerType($event)"
                           id="customCheckPayer" />
                    <label class="custom-control-label" style="line-height: 25px;"
                           for="customCheckPayer" translate>lblCompany</label>
                  </div>
                  <div *ngIf="!editCustomerPayerForm.get('isCompany').value" class="mt-25" style="margin-left:90px ;">
                    <div class="col-auto">
                        <div class="p-0 d-flex">
                            <input type="radio" id="Male" formControlName="gender" value="0" name="gender"
                            class="radio-custom" />
                            <label class="form-check-label" style="line-height: 25px;"  for="Male" translate>lblMale</label>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class=" p-0 d-flex">
                            <input type="radio" id="Female"  formControlName="gender" value="1" name="gender" 
                            class="radio-custom"  />
                            <label class="form-check-label" style="line-height: 25px;"  for="Female" translate>lblFemale</label>
                        </div>
                    </div>
                </div> 
                </div>
                <div class="col-3 af-form-group">
                  <label for="CustomerNo" translate>
                    lblCustomerNumber

                  </label>
                  <div class="lbl-info input-group">
                    <input formControlName="customerNo" class="form-control" type="text"
                           name="searchTerm" autocomplete="off"  (keyup.enter)="onSearchCustomerNo(editCustomerPayerForm.value.customerNo,'Payer')"/>
                    <div class="input-group-append" >
                      <button type="button" class="btn btn-primary" (click)="onSearchCustomerNo(editCustomerPayerForm.value.customerNo,'Payer')">
                        <em class="fa fa-search"></em>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="col-3 af-form-group" *ngIf="!editCustomerPayerForm.get('isCompany').value && !editPayer">
                  <label class="text" for="customerName" translate>
                    lblCustomerName
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class="lbl-info">
                    <input formControlName="customerName" class="form-control mb-2"
                           [ngClass]="{'is-invalid': cpfPayer.customerName.invalid}">
                    <div *ngIf="cpfPayer.customerName.touched && (cpfPayer.customerName.errors?.required)"
                         class="help-block mt-1 text-danger" translate>
                      <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                      lblCustomerNameRequired
                    </div>
                  </div>
                </div>

                <div class="col-3 af-form-group" *ngIf="editCustomerPayerForm.get('isCompany').value">
                  <label class="text" for="customerName" translate>
                    lblCompanyName
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class="lbl-info">
                    <input formControlName="customerName" class="form-control mb-2"
                           [ngClass]="{'is-invalid': cpfPayer.customerName.invalid}">
                    <div *ngIf="cpfPayer.customerName.touched && (cpfPayer.customerName.errors?.required)"
                         class="help-block mt-1 text-danger" translate>
                      <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                      lblRequiredisCompanyName
                    </div>
                  </div>
                </div>

                <div class="col-2 af-form-group" *ngIf="!editCustomerPayerForm.get('isCompany').value &&  editPayer">
                  <label class="text" for="firstName" translate>
                    lblFirstName
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class="lbl-info">
                    <input formControlName="firstName" class="form-control mb-2"
                           [ngClass]="{'is-invalid': cpfPayer.firstName.invalid}">
                    <div *ngIf="cpfPayer.firstName.touched && (cpfPayer.firstName.errors?.required)"
                         class="help-block mt-1 text-danger" translate>
                      <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                      lblRequiredFirstName
                    </div>
                  </div>
                </div>

                <div class="col-2 af-form-group" *ngIf="!editCustomerPayerForm.get('isCompany').value &&  editPayer">
                  <label class="text" for="lastName" translate>
                    lblLastName
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class="lbl-info">
                    <input formControlName="lastName" class="form-control mb-2"
                           [ngClass]="{'is-invalid': cpfPayer.lastName.invalid}">
                    <div *ngIf="cpfPayer.lastName.touched && (cpfPayer.lastName.errors?.required)"
                         class="help-block mt-1 text-danger" translate>
                      <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                      lbRequiredlLastName
                    </div>
                  </div>
                </div>


                <div class="col-3 af-form-group">
                  <label class="text" for="address1" translate>
                    lblAddress1
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class="lbl-info">
                    <input formControlName="address1" class="form-control mb-2"
                           [ngClass]="{'is-invalid': cpfPayer.address1.invalid}">
                    <div *ngIf="cpfPayer.address1.touched && (cpfPayer.address1.errors?.required)"
                         class="help-block mt-1 text-danger" translate>
                      <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                      lblAddress1isRequired
                    </div>
                  </div>
                </div>

                <div class="col-3 af-form-group">
                  <label class="text" for="address2" translate>
                    lblAddress2
                  </label>
                  <div class="lbl-info">
                    <input formControlName="address2" class="form-control mb-2"
                           [ngClass]="{'is-invalid': cpfPayer.address2.invalid}">
                  </div>
                </div>

                <div class="col-3 af-form-group">
                  <label class="text" for="postCode" translate>
                    lblPostCode
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <ng-select formControlName="postCode" placeholder="{{ 'lblSelectPostCode' | translate }}" required
                        [(ngModel)]="postcodeNamePayer" (change)="onPostCodeSelected($event,'Payer')">
                        <ng-option *ngFor="let item of postCodeListPayer" [value]="item.code">
                            {{item.code}}</ng-option>
                    </ng-select>
                    <div *ngIf="cpfPayer.postCode && cpfPayer.postCode.invalid && (cpfPayer.postCode.dirty || cpfPayer.postCode.touched)"
                        class="help-block text-danger">
                        <div *ngIf="cpfPayer.postCode.errors.required"><span translate>lblPostCodeisRequired</span>
                        </div>
                    </div>
                </div>
                </div>

                <div class="col-3 af-form-group">
                  <label class="text" for="city" translate>
                    lblCity
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class='lbl-info'>
                    <ng-select formControlName="city" placeholder="{{ 'lblSelectCity' | translate }}" [(ngModel)]="cityNamePayer" required
                      (change)="onCitySelected($event,'Payer')">
                      <ng-option *ngFor="let item of cityListPayer" [value]="item">
                        {{item}}</ng-option>
                    </ng-select>
                    <div *ngIf="cpfPayer.city && cpfPayer.city.invalid && (cpfPayer.city.dirty || cpfPayer.city.touched)" class="help-block text-danger">
                      <div *ngIf="cpfPayer.city.errors.required"><span translate>lblCityisRequired</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-3 af-form-group">
                  <label class="text" for="mobileNo" translate>
                    lblMobileNo
                  </label>
                  <div class="lbl-info">              
                    <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="mobileNo" [cssClass]="{'form-control': true}"
                    [selectedCountryISO]="selectedCountryISOMobilePayer" [maxLength]="15" [phoneValidation]="false"
                    [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                    [customPlaceholder]="'lblEnterMobile' | translate" (keyup)="onMobilePayerChange()"
                    (countryChange)="onCountryChange($event,'Payer')"
                    ></ngx-intl-tel-input>
                    <div *ngIf="(cpfPayer.mobileNo.touched || cpfPayer.mobileNo.dirty) && cpfPayer.mobileNo.errors">
                      <div *ngIf="cpfPayer.mobileNo.errors.pattern"
                           class="help-block mt-1 text-danger" translate>
                        lblEnterValidMobile
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-3 af-form-group  ">
                  <label class="text" for="phoneNumber" translate>
                    lblPhoneNumber
                  </label>
                  <div class="lbl-info">            
                    <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="phoneNumber" [cssClass]="{'form-control': true, 'is-invalid': cpfPayer.phoneNumber.invalid}"
                    [selectedCountryISO]="selectedCountryISOPhonePayer" [maxLength]="15" [phoneValidation]="false"
                    [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false" (keyup)="onLandlinePayerChange()"
                    (countryChange)="onCountryChangePhoneNumber($event,'Payer')"
                    ></ngx-intl-tel-input>
                  </div>
                </div>

                <div class="col-3 af-form-group ">
                  <label class="text" for="email" translate>
                    lblEmail
                    <strong class="mlt6 required"> * </strong>
                  </label>
                  <div class="lbl-info">
                    <input formControlName="email" class="form-control mb-2"
                           [ngClass]="{'is-invalid': cpfPayer.email.invalid}">
                    <div *ngIf="cpfPayer.email.touched && (cpfPayer.email.errors?.required)"
                         class="help-block mt-1 text-danger" translate>
                      <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                      lblEmailisRequired
                    </div>
                  </div>
                </div>

                <div class="col-3 af-form-group ">
                    <label class="text" for="dob" translate *ngIf="editCustomerPayerForm.get('isCompany').value">
                        <span translate>lblRegistrationDate</span>
                      </label>
                      <label class="text" for="dob" translate *ngIf="!editCustomerPayerForm.get('isCompany').value">
                        <span translate>lblDateOfBirth</span>
                      </label>
                  <div class="lbl-info cal-date">
                    <input class="form-control datePicker width100force" appAfDatepicker
                           autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false"
                           id="txtdateOfBirth" formControlName="dob" [(ngModel)]="dobPayer"
                           name="dateOfBirth" type="text" value="" [endDate]="endDate">
                    <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                  </div>
                </div>

                <div class="col-3 af-form-group  ">
                  <label class="text mt-25" for="isActive" translate>
                    <ng-container *ngIf="customerDetails.customerPayer?.isActive; else load_else_isActiveCustomerPayer">
                      <em class="fas fa-check fa-lg"></em>
                  </ng-container>
                  <ng-template #load_else_isActiveCustomerPayer>
                      <em class="fas fa-times text-danger cursordisable"></em>
                  </ng-template> 
                  <span translate class="ml-2">lblIsActive</span>
                  </label>
                </div>

              </div>

              <div class="p-3" *ngIf="editPayer">
                <div class="row" >
                  <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                    <button type="submit" class="btn btn-primary btn-lg mr-sm-2"
                            [disabled]="!editCustomerPayerForm.valid " translate
                            aria-label="Center Align">
                      lblUpdate
                    </button>
                    <a (click)="Cancelform('Payer')" class="btn btn-secondary btn-lg" translate>lblCancel</a>
                  </div>
                </div>
              </div>

            </form>
          </div>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="Owner">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left py-1-5
" aria-label="Center Align">
              lblOwner

              <span *ngIf="customerDetails && customerDetails.customerOwner"
                    class="text-capitalize fs-16px flmid clr666">
                    <span class="mx-3">-</span>
                {{customerDetails.customerOwner.customerNo}} -
                {{customerDetails.customerOwner.customerName}}
                <span class="clrbluebright clrhoverthemegrey flmid" (click)="open(content,customerDetails.customerOwner); $event.stopPropagation()">
                  <em class="clrbluebright clrhoverthemegrey fas fa-phone-volume fs-16px fa-lg mr-2 ml-3"></em>
                  <span class="clrbluebright clrhoverthemegrey">+{{customerDetails.customerOwner.dialCode}}-{{customerDetails.customerOwner.mobileNo}}</span>
                </span>
              </span>
              <div class="ml-auto">
                <button *ngIf="customerDetails && customerDetails.customerOwner" type="button" (click)="isEditMethod('Owner',true)"
                  class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                  lblEdit
                </button>
                <button *ngIf="customerDetails && customerDetails.customerOwner" type="button" (click)="viewCustomer(customerDetails.customerOwner)"
                  class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                  lblViewCustomer
                </button>
                <button *ngIf="customerDetails && customerDetails.customerOwner" type="button" (click)="DeleteRelation('Owner',customerDetails.customerOwner)"
                class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                lblDelete
                </button>
                <ng-container *ngIf="!acc.activeIds.includes('owner')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
                </ng-container>
                <ng-container *ngIf="acc.activeIds.includes('owner')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
                </ng-container>
              </div>
            </button>



          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <form [formGroup]="editCustomerOwnerForm" (ngSubmit)="onSaveCustomer('Owner',customerDetails.customerOwner.customerId)">
            <div class="form-row">
              <div class="col-3 af-form-group d-flex align-content-between">
                <div class="custom-control custom-checkbox mt-25">
                  <input class="custom-control-input" type="checkbox" formControlName="isCompany" (change)="changeCustomerType($event)"
                         id="customCheckOwner" />
                  <label class="custom-control-label" style="line-height: 25px;" for="customCheckOwner"
                         translate>lblCompany</label>
                </div>
                <div *ngIf="!editCustomerOwnerForm.get('isCompany').value" class="mt-25" style="margin-left:90px;">
                  <div class="col-auto">
                      <div class="p-0 d-flex">
                          <input type="radio" id="Male" formControlName="gender" value="0" name="gender"
                          class="radio-custom" />
                          <label class="form-check-label" style="line-height: 25px;"  for="Male" translate>lblMale</label>
                      </div>
                  </div>
                  <div class="col-auto">
                      <div class="p-0 d-flex">
                          <input type="radio" id="Female"  formControlName="gender" value="1" name="gender" 
                          class="radio-custom"  />
                          <label class="form-check-label" style="line-height: 25px;"  for="Female" translate>lblFemale</label>
                      </div>
                  </div>
              </div> 
              </div>
              <div class="col-3 af-form-group">
                <label for="CustomerNo" translate>
                  lblCustomerNumber
                </label>
                <div class="lbl-info  input-group">
                  <input formControlName="customerNo" class="form-control" type="text"
                         name="searchTerm" autocomplete="off" (keyup.enter)="onSearchCustomerNo(editCustomerOwnerForm.value.customerNo,'Owner')"/>
                  <div class="input-group-append">
                    <button type="button" class="btn btn-primary" (click)="onSearchCustomerNo(editCustomerOwnerForm.value.customerNo,'Owner')">
                      <em class="fa fa-search"></em>
                    </button>
                </div>
                </div>
              </div>

              <div class="col-3 af-form-group" *ngIf="!editCustomerOwnerForm.get('isCompany').value && !editOwner">
                <label class="text" for="customerName" translate>
                  lblCustomerName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="customerName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfOwner.customerName.invalid}">
                  <div *ngIf="cpfOwner.customerName.touched && (cpfOwner.customerName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblCustomerNameRequired
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group" *ngIf="editCustomerOwnerForm.get('isCompany').value">
                <label class="text" for="customerName" translate>
                  lblCompanyName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="customerName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfOwner.customerName.invalid}">
                  <div *ngIf="cpfOwner.customerName.touched && (cpfOwner.customerName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblRequiredisCompanyName
                  </div>
                </div>
              </div>

              <div class="col-2 af-form-group" *ngIf="!editCustomerOwnerForm.get('isCompany').value &&  editOwner">
                <label class="text" for="firstName" translate>
                  lblFirstName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="firstName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfOwner.firstName.invalid}">
                  <div *ngIf="cpfOwner.firstName.touched && (cpfOwner.firstName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblRequiredFirstName
                  </div>
                </div>
              </div>

              <div class="col-2 af-form-group" *ngIf="!editCustomerOwnerForm.get('isCompany').value &&  editOwner">
                <label class="text" for="lastName" translate>
                  lblLastName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="lastName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfOwner.lastName.invalid}">
                  <div *ngIf="cpfOwner.lastName.touched && (cpfOwner.lastName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lbRequiredlLastName
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="address1" translate>
                  lblAddress1
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="address1" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfOwner.address1.invalid}">
                  <div *ngIf="cpfOwner.address1.touched && (cpfOwner.address1.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblAddress1isRequired
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="address2" translate>
                  lblAddress2
                </label>
                <div class="lbl-info">
                  <input formControlName="address2" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfOwner.address2.invalid}">
                </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="postCode" translate>
                  lblPostCode
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class='lbl-info'>
                  <ng-select formControlName="postCode" placeholder="{{ 'lblSelectPostCode' | translate }}" required
                    [(ngModel)]="postcodeNameOwner" (change)="onPostCodeSelected($event,'Owner')">
                    <ng-option *ngFor="let item of postCodeListOwner" [value]="item.code">
                      {{item.code}}</ng-option>
                  </ng-select>
                  <div *ngIf="cpfOwner.postCode && cpfOwner.postCode.invalid && (cpfOwner.postCode.dirty || cpfOwner.postCode.touched)"
                    class="help-block text-danger">
                    <div *ngIf="cpfOwner.postCode.errors.required"><span translate>lblPostCodeisRequired</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="city" translate>
                  lblCity
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class='lbl-info'>
                  <ng-select formControlName="city" placeholder="{{ 'lblSelectCity' | translate }}" [(ngModel)]="cityNameOwner" required
                    (change)="onCitySelected($event,'Owner')">
                    <ng-option *ngFor="let item of cityListOwner" [value]="item">
                      {{item}}</ng-option>
                  </ng-select>
                  <div *ngIf="cpfOwner.city && cpfOwner.city.invalid && (cpfOwner.city.dirty || cpfOwner.city.touched)" class="help-block text-danger">
                    <div *ngIf="cpfOwner.city.errors.required"><span translate>lblCityisRequired</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group ">
                <label class="text" for="mobileNo" translate>
                  lblMobileNo
                </label>
                <div class="lbl-info">
                  <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="mobileNo" [cssClass]="{'form-control': true}"
                  [selectedCountryISO]="selectedCountryISOMobileOwner" [maxLength]="15" [phoneValidation]="false"
                  [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                  [customPlaceholder]=" 'lblEnterMobile' | translate " (keyup)="onMobileOwnerChange()"
                  (countryChange)="onCountryChange($event,'Owner')"
                  ></ngx-intl-tel-input>
                  <div *ngIf="(cpfOwner.mobileNo.touched || cpfOwner.mobileNo.dirty) && cpfOwner.mobileNo.errors">
                    <div *ngIf="cpfOwner.mobileNo.errors.pattern"
                         class="help-block mt-1 text-danger" translate>
                      lblEnterValidMobile
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group  ">
                <label class="text" for="phoneNumber" translate>
                  lblPhoneNumber
                </label>
                <div class="lbl-info">
                  <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="phoneNumber" [cssClass]="{ 'form-control': true, 'is-invalid': cpfOwner.phoneNumber.invalid}"
                  [selectedCountryISO]="selectedCountryISOPhoneOwner" [maxLength]="15" [phoneValidation]="false"
                  [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false" (keyup)="onLandlineOwnerChange()"
                  (countryChange)="onCountryChangePhoneNumber($event,'Owner')"
                  ></ngx-intl-tel-input>
                  </div>
              </div>

              <div class="col-3 af-form-group ">
                <label class="text" for="email" translate>
                  lblEmail
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="email" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfOwner.email.invalid}">
                  <div *ngIf="cpfOwner.email.touched && (cpfOwner.email.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblEmailisRequired
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group  ">
                <label class="text" for="dob" translate *ngIf="editCustomerOwnerForm.get('isCompany').value">
                  <span translate>lblRegistrationDate</span>
                </label>
                <label class="text" for="dob" translate *ngIf="!editCustomerOwnerForm.get('isCompany').value">
                  <span translate>lblDateOfBirth</span>
                </label>

                <div class="lbl-info cal-date">
                  <input class="form-control datePicker width100force" appAfDatepicker
                         autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false"
                         id="txtdateOfBirth" formControlName="dob" [(ngModel)]="dobOwner"
                         name="dateOfBirth" type="text" value="" [endDate]="endDate">
                  <em class="fas fa-calendar-alt fa-lg cursordisable"></em>

                </div>
              </div>

              <div class="col-3 af-form-group  ">
                <label class="text mt-25" for="isActive" translate>
                  <ng-container *ngIf="customerDetails.customerOwner?.isActive; else load_else_isActiveCustomerOwner">
                    <em class="fas fa-check fa-lg"></em>
                </ng-container>
                <ng-template #load_else_isActiveCustomerOwner>
                    <em class="fas fa-times text-danger cursordisable"></em>
                </ng-template> 
                <span translate class="ml-2">lblIsActive</span>
                </label>
              </div>

            </div>
            <div class="p-3 " *ngIf="editOwner">
              <div class="row" >
                <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                  <button type="submit" class="btn btn-primary btn-lg mr-sm-2"
                          [disabled]="!editCustomerOwnerForm.valid " translate
                          aria-label="Center Align">
                    lblUpdate
                  </button>
                  <a (click)="Cancelform('Owner')" class="btn btn-secondary btn-lg" translate>lblCancel</a>
                </div>
              </div>
            </div>
          </form>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="User">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left py-1-5
" aria-label="Center Align">
              lblUser

              <span *ngIf="customerDetails && customerDetails.customerUser"
                    class="text-capitalize fs-16px flmid clr666">
                    <span class="mx-3">-</span>
                {{customerDetails.customerUser.customerNo}} -
                {{customerDetails.customerUser.customerName}}
                <span class="clrbluebright clrhoverthemegrey flmid" (click)="open(content,customerDetails.customerUser); $event.stopPropagation()">
                  <em class="clrbluebright clrhoverthemegrey fas fa-phone-volume fs-16px fa-lg mr-2 ml-3"></em>
                  <span class="clrbluebright clrhoverthemegrey">+{{customerDetails.customerUser.dialCode}}-{{customerDetails.customerUser.mobileNo}}</span>
                </span>
              </span>
              <div class="ml-auto">
                <button *ngIf="customerDetails && customerDetails.customerUser" type="button" (click)="isEditMethod('User',true)"
                  class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                  lblEdit
                </button>
                <button *ngIf="customerDetails && customerDetails.customerUser" type="button" (click)="viewCustomer(customerDetails.customerUser)"
                  class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                  lblViewCustomer
                </button>
                <button *ngIf="customerDetails && customerDetails.customerUser" type="button" (click)="DeleteRelation('User',customerDetails.customerUser)"
                class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                lblDelete
                </button>
                
                <ng-container *ngIf="!acc.activeIds.includes('user')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
                </ng-container>
                <ng-container *ngIf="acc.activeIds.includes('user')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
                </ng-container>
              </div>
            </button>

          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <form [formGroup]="editCustomerUserForm" (ngSubmit)="onSaveCustomer('User',customerDetails.customerUser.customerId)">
            <div class="form-row">
              <div class="col-3 af-form-group d-flex align-content-between">
                <div class="custom-control custom-checkbox mt-25">
                  <input class="custom-control-input" type="checkbox" formControlName="isCompany" (change)="changeCustomerType($event)"
                         id="customCheckUser" />
                  <label class="custom-control-label" style="line-height: 25px;" for="customCheckUser"
                         translate>lblCompany</label>
                </div>
                <div *ngIf="!editCustomerUserForm.get('isCompany').value" class="mt-25" style="margin-left:90px;">
                  <div class="col-auto">
                      <div class="p-0 d-flex">
                          <input type="radio" id="Male" formControlName="gender" value="0" name="gender"
                          class="radio-custom" />
                          <label class="form-check-label" style="line-height: 25px;"  for="Male" translate>lblMale</label>
                      </div>
                  </div>
                  <div class="col-auto">
                      <div class="d-flex p-0">
                          <input type="radio" id="Female"  formControlName="gender" value="1" name="gender" 
                          class="radio-custom"  />
                          <label class="form-check-label" style="line-height: 25px;"  for="Female" translate>lblFemale</label>
                      </div>
                  </div>
              </div> 
              </div>
              <div class="col-3 af-form-group">
                <label for="CustomerNo" translate>
                  lblCustomerNumber
                </label>
                <div class="lbl-info  input-group">
                  <input formControlName="customerNo" class="form-control" type="text"
                         name="searchTerm" autocomplete="off" (keyup.enter)="onSearchCustomerNo(editCustomerUserForm.value.customerNo,'User')"/>
                        <div class="input-group-append">
                          <button type="button" class="btn btn-primary" (click)="onSearchCustomerNo(editCustomerUserForm.value.customerNo,'User')">
                            <em class="fa fa-search"></em>
                          </button>
                        </div>
                </div>
              </div>

              <div class="col-3 af-form-group" *ngIf="!editCustomerUserForm.get('isCompany').value && !editUser">
                <label class="text" for="customerName" translate>
                  lblCustomerName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="customerName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfUser.customerName.invalid}">
                  <div *ngIf="cpfUser.customerName.touched && (cpfUser.customerName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblCustomerNameRequired
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group" *ngIf="editCustomerUserForm.get('isCompany').value">
                <label class="text" for="customerName" translate>
                  lblCompanyName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="customerName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfUser.customerName.invalid}">
                  <div *ngIf="cpfUser.customerName.touched && (cpfUser.customerName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblRequiredisCompanyName
                  </div>
                </div>
              </div>

              <div class="col-2 af-form-group" *ngIf="!editCustomerUserForm.get('isCompany').value &&  editUser">
                <label class="text" for="firstName" translate>
                  lblFirstName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="firstName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfUser.firstName.invalid}">
                  <div *ngIf="cpfUser.firstName.touched && (cpfUser.firstName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblRequiredFirstName
                  </div>
                </div>
              </div>

              <div class="col-2 af-form-group" *ngIf="!editCustomerUserForm.get('isCompany').value &&  editUser">
                <label class="text" for="lastName" translate>
                  lblLastName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="lastName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfUser.lastName.invalid}">
                  <div *ngIf="cpfUser.lastName.touched && (cpfUser.lastName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lbRequiredlLastName
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="address1" translate>
                  lblAddress1
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="address1" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfUser.address1.invalid}">
                  <div *ngIf="cpfUser.address1.touched && (cpfUser.address1.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblAddress1isRequired
                  </div>
                </div>
              </div>
              <div class="col-3 af-form-group">
                <label class="text" for="address2" translate>
                  lblAddress2
                </label>
                <div class="lbl-info">
                  <input formControlName="address2" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfUser.address2.invalid}">
                </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="postCode" translate>
                  lblPostCode
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class='lbl-info'>
                  <ng-select formControlName="postCode" placeholder="{{ 'lblSelectPostCode' | translate }}" required
                      [(ngModel)]="postcodeNameUser" (change)="onPostCodeSelected($event,'User')">
                      <ng-option *ngFor="let item of postCodeListUser" [value]="item.code">
                          {{item.code}}</ng-option>
                  </ng-select>
                  <div *ngIf="cpfUser.postCode && cpfUser.postCode.invalid && (cpfUser.postCode.dirty || cpfUser.postCode.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpfUser.postCode.errors.required"><span translate>lblPostCodeisRequired</span>
                      </div>
                  </div>
              </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="city" translate>
                  lblCity
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class='lbl-info'>
                  <ng-select formControlName="city" placeholder="{{ 'lblSelectCity' | translate }}" [(ngModel)]="cityNameUser" required
                    (change)="onCitySelected($event,'User')">
                    <ng-option *ngFor="let item of cityListUser" [value]="item">
                      {{item}}</ng-option>
                  </ng-select>
                  <div *ngIf="cpfUser.city && cpfUser.city.invalid && (cpfUser.city.dirty || cpfUser.city.touched)" class="help-block text-danger">
                    <div *ngIf="cpfUser.city.errors.required"><span translate>lblCityisRequired</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="mobileNo" translate>
                  lblMobileNo
                </label>
                <div class="lbl-info">
                  <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="mobileNo" [cssClass]="{'form-control': true}"
                  [selectedCountryISO]="selectedCountryISOMobileUser" [maxLength]="15" [phoneValidation]="false"
                  [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                  [customPlaceholder]=" 'lblEnterMobile' | translate " (keyup)="onMobileUserChange()"
                  (countryChange)="onCountryChange($event,'User')"
                  ></ngx-intl-tel-input>
                  <div *ngIf="(cpfUser.mobileNo.touched || cpfUser.mobileNo.dirty) && cpfUser.mobileNo.errors">
                    <div *ngIf="cpfUser.mobileNo.errors.pattern" class="help-block mt-1 text-danger"
                         translate>
                      lblEnterValidMobile
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group ">
                <label class="text" for="phoneNumber" translate>
                  lblPhoneNumber
                </label>
                <div class="lbl-info">
                  <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="phoneNumber" [cssClass]="{'form-control': true, 'is-invalid': cpfUser.phoneNumber.invalid}"
                  [selectedCountryISO]="selectedCountryISOPhoneUser" [maxLength]="15" [phoneValidation]="false"
                  [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false" (keyup)="onLandlineUserChange()"
                  (countryChange)="onCountryChangePhoneNumber($event,'User')"
                  ></ngx-intl-tel-input>
                  </div>
              </div>

              <div class="col-3 af-form-group  ">
                <label class="text" for="email" translate>
                  lblEmail
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="email" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfUser.email.invalid}">
                  <div *ngIf="cpfUser.email.touched && (cpfUser.email.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblEmailisRequired
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group  ">
                  <label class="text" for="dob" translate *ngIf="editCustomerUserForm.get('isCompany').value">
                      <span translate>lblRegistrationDate</span>
                    </label>
                    <label class="text" for="dob" translate *ngIf="!editCustomerUserForm.get('isCompany').value">
                      <span translate>lblDateOfBirth</span>
                    </label>
                <div class="lbl-info cal-date">
                  <input class="form-control datePicker width100force" appAfDatepicker
                         autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false"
                         id="txtdateOfBirth" formControlName="dob" [(ngModel)]="dobUser"
                         name="dateOfBirth" type="text" value="" [endDate]="endDate">
                  <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                </div>
              </div>

              <div class="col-3 af-form-group  ">
                <label class="text mt-25" for="isActive" translate>
                  <ng-container *ngIf="customerDetails.customerUser?.isActive; else load_else_isActiveCustomerUser">
                    <em class="fas fa-check fa-lg"></em>
                </ng-container>
                <ng-template #load_else_isActiveCustomerUser>
                    <em class="fas fa-times text-danger cursordisable"></em>
                </ng-template> 
                <span translate class="ml-2">lblIsActive</span>
                </label>
              </div>

            </div>
            <div class="p-3" *ngIf="editUser">
              <div class="row" >
                <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                  <button type="submit" class="btn btn-primary btn-lg mr-sm-2"
                          [disabled]="!editCustomerUserForm.valid " translate
                          aria-label="Center Align">
                    lblUpdate
                  </button>
                  <a (click)="Cancelform('User')" class="btn btn-secondary btn-lg" translate>lblCancel</a>
                </div>
              </div>
            </div>
          </form>
        </ng-template>
      </ngb-panel>

      <ngb-panel id="Driver" *ngIf="!hidePayerAndDriver">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left py-1-5
" aria-label="Center Align">
              lblDriver

              <span *ngIf="customerDetails && customerDetails.customerDriver"
                    class="text-capitalize fs-16px flmid clr666">
                    <span class="mx-3">-</span>
                {{customerDetails.customerDriver.customerNo}} -
                {{customerDetails.customerDriver.customerName}}
                <span class="clrbluebright clrhoverthemegrey flmid" (click)="open(content,customerDetails.customerDriver); $event.stopPropagation()">
                  <em class="clrbluebright clrhoverthemegrey fas fa-phone-volume fs-16px fa-lg mr-2 ml-3"></em>
                  <span class="clrbluebright clrhoverthemegrey">+{{customerDetails.customerDriver.dialCode}}-{{customerDetails.customerDriver.mobileNo}}</span>
                </span>
              </span>
              <div class="ml-auto">
                <button *ngIf="customerDetails && customerDetails.customerDriver" type="button" (click)="isEditMethod('Driver',true)"
                  class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                  lblEdit
                </button>
                <button *ngIf="customerDetails && customerDetails.customerDriver" type="button" (click)="viewCustomer(customerDetails.customerDriver)"
                  class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                  lblViewCustomer
                </button>
                <button *ngIf="customerDetails && customerDetails.customerDriver" type="button" (click)="DeleteRelation('Driver',customerDetails.customerDriver)"
                class="btn btn-outline-primary px-3 py-1 mr-2" translate aria-label="Center Align">
                lblDelete
                </button>
                <ng-container *ngIf="!acc.activeIds.includes('driver')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
                </ng-container>
                <ng-container *ngIf="acc.activeIds.includes('driver')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
                </ng-container>
              </div>
            </button>

          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <form [formGroup]="editCustomerDriverForm" (ngSubmit)="onSaveCustomer('Driver',customerDetails.customerDriver.customerId)">
            <div class="form-row">
              <div class="col-3 af-form-group d-flex align-content-between">
                <div class="custom-control custom-checkbox mt-25">
                  <input class="custom-control-input" type="checkbox" formControlName="isCompany" (change)="changeCustomerType($event)"
                         id="customCheckDriver" disabled />
                  <label class="custom-control-label" style="line-height: 25px;" for="customCheckDriver"
                         translate>lblCompany</label>
                </div>
                <div *ngIf="!editCustomerDriverForm.get('isCompany').value" class="mt-25" style="margin-left:90px;">
                  <div class="col-auto">
                      <div class="d-flex p-0">
                          <input type="radio" id="Male" formControlName="gender" value="0" name="gender"
                          class="radio-custom" />
                          <label class="form-check-label" style="line-height: 25px;"  for="Male" translate>lblMale</label>
                      </div>
                  </div>
                  <div class="col-auto">
                      <div class="d-flex p-0">
                          <input type="radio" id="Female"  formControlName="gender" value="1" name="gender" 
                          class="radio-custom"  />
                          <label class="form-check-label" style="line-height: 25px;"  for="Female" translate>lblFemale</label>
                      </div>
                  </div>
              </div> 
              </div>
              <div class="col-3 af-form-group">
                <label for="CustomerNo" translate>
                  lblCustomerNumber
                </label>
                <div class="lbl-info  input-group">
                 <input formControlName="customerNo" class="form-control" type="text"
                         name="searchTerm" autocomplete="off" (keyup.enter)="onSearchCustomerNo(editCustomerDriverForm.value.customerNo,'Driver')"/>
                         <div class="input-group-append">
                          <button type="button" class="btn btn-primary" (click)="onSearchCustomerNo(editCustomerDriverForm.value.customerNo,'Driver')">
                            <em class="fa fa-search"></em>
                          </button>
                        </div>
                </div>
              </div>

              <div class="col-3 af-form-group" *ngIf="!editCustomerDriverForm.get('isCompany').value && !editDriver">
                <label class="text" for="customerName" translate>
                  lblCustomerName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="customerName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfDriver.customerName.invalid}">
                  <div *ngIf="cpfDriver.customerName.touched && (cpfDriver.customerName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblCustomerNameRequired
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group" *ngIf="editCustomerDriverForm.get('isCompany').value">
                <label class="text" for="customerName" translate>
                  lblCompanyName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="customerName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfDriver.customerName.invalid}">
                  <div *ngIf="cpfDriver.customerName.touched && (cpfDriver.customerName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblRequiredisCompanyName
                  </div>
                </div>
              </div>

              <div class="col-2 af-form-group" *ngIf="!editCustomerDriverForm.get('isCompany').value &&  editDriver">
                <label class="text" for="firstName" translate>
                  lblFirstName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="firstName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfDriver.firstName.invalid}">
                  <div *ngIf="cpfDriver.firstName.touched && (cpfDriver.firstName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblRequiredFirstName
                  </div>
                </div>
              </div>

              <div class="col-2 af-form-group" *ngIf="!editCustomerDriverForm.get('isCompany').value &&  editDriver">
                <label class="text" for="lastName" translate>
                  lblLastName
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="lastName" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfDriver.lastName.invalid}">
                  <div *ngIf="cpfDriver.lastName.touched && (cpfDriver.lastName.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lbRequiredlLastName
                  </div>
                </div>
              </div>



              <div class="col-3 af-form-group">
                <label class="text" for="address1" translate>
                  lblAddress1
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="address1" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfDriver.address1.invalid}">
                  <div *ngIf="cpfDriver.address1.touched && (cpfDriver.address1.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblAddress1isRequired
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="address2" translate>
                  lblAddress2
                </label>
                <div class="lbl-info">
                  <input formControlName="address2" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfDriver.address2.invalid}">
                </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="postCode" translate>
                  lblPostCode
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class='lbl-info'>
                  <ng-select formControlName="postCode" placeholder="{{ 'lblSelectPostCode' | translate }}" required
                    [(ngModel)]="postcodeNameDriver" (change)="onPostCodeSelected($event,'Driver')">
                    <ng-option *ngFor="let item of postCodeListDriver" [value]="item.code">
                      {{item.code}}</ng-option>
                  </ng-select>
                  <div
                    *ngIf="cpfDriver.postCode && cpfDriver.postCode.invalid && (cpfDriver.postCode.dirty || cpfDriver.postCode.touched)"
                    class="help-block text-danger">
                    <div *ngIf="cpfDriver.postCode.errors.required"><span translate>lblPostCodeisRequired</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="city" translate>
                  lblCity
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class='lbl-info'>
                  <ng-select formControlName="city" placeholder="{{ 'lblSelectCity' | translate }}" [(ngModel)]="cityNameDriver" required
                    (change)="onCitySelected($event,'Driver')">
                    <ng-option *ngFor="let item of cityListDriver" [value]="item">
                      {{item}}</ng-option>
                  </ng-select>
                  <div *ngIf="cpfDriver.city && cpfDriver.city.invalid && (cpfDriver.city.dirty || cpfUser.city.touched)" class="help-block text-danger">
                    <div *ngIf="cpfDriver.city.errors.required"><span translate>lblCityisRequired</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group">
                <label class="text" for="mobileNo" translate>
                  lblMobileNo
                </label>
                <div class="lbl-info">
                  <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="mobileNo" [cssClass]="{'form-control': true}"
                  [selectedCountryISO]="selectedCountryISOMobileDriver" [maxLength]="15" [phoneValidation]="false"
                  [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                  [customPlaceholder]=" 'lblEnterMobile' | translate " (keyup)="onMobileDriverChange()"
                  (countryChange)="onCountryChange($event,'Driver')"
                  ></ngx-intl-tel-input>
                  <div *ngIf="(cpfDriver.mobileNo.touched || cpfDriver.mobileNo.dirty) && cpfDriver.mobileNo.errors">
                    <div *ngIf="cpfDriver.mobileNo.errors.pattern"
                         class="help-block mt-1 text-danger" translate>
                      lblEnterValidMobile
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group  ">
                <label class="text" for="phoneNumber" translate>
                  lblPhoneNumber
                </label>
                <div class="lbl-info">
                  <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="phoneNumber" [cssClass]="{'form-control': true, 'is-invalid': cpfDriver.phoneNumber.invalid}"
                  [selectedCountryISO]="selectedCountryISOPhoneDriver" [maxLength]="15" [phoneValidation]="false"
                  [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false"
                  (countryChange)="onCountryChangePhoneNumber($event,'Driver')" (keyup)="onLandlineDriverChange()"
                  ></ngx-intl-tel-input>
                </div>
              </div>

              <div class="col-3 af-form-group  ">
                <label class="text" for="email" translate>
                  lblEmail
                  <strong class="mlt6 required"> * </strong>
                </label>
                <div class="lbl-info">
                  <input formControlName="email" class="form-control mb-2"
                         [ngClass]="{'is-invalid': cpfDriver.email.invalid}">
                  <div *ngIf="cpfDriver.email.touched && (cpfDriver.email.errors?.required)"
                       class="help-block mt-1 text-danger" translate>
                    <em class="ft-alert-circle align-middle" aria-hidden="true"></em>
                    lblEmailisRequired
                  </div>
                </div>
              </div>

              <div class="col-3 af-form-group  ">
                  <label class="text" for="dob" translate *ngIf="editCustomerDriverForm.get('isCompany').value">
                      <span translate>lblRegistrationDate</span>
                    </label>
                    <label class="text" for="dob" translate *ngIf="!editCustomerDriverForm.get('isCompany').value">
                      <span translate>lblDateOfBirth</span>
                    </label>
                <div class="lbl-info cal-date">
                  <input class="form-control datePicker width100force" appAfDatepicker
                         autocomplete="off" [startDate]="'1900/01/01'" [dateTime]="false"
                         id="txtdateOfBirth" formControlName="dob" [(ngModel)]="dobDriver"
                         name="dateOfBirth" type="text" value="" [endDate]="endDate">
                  <em class="fas fa-calendar-alt fa-lg cursordisable"></em>
                </div>
              </div>

              <div class="col-3 af-form-group  ">
                <label class="text mt-25" for="isActive" translate>
                  <ng-container *ngIf="customerDetails.customerDriver?.isActive; else load_else_isActiveCustomerDriver">
                    <em class="fas fa-check fa-lg"></em>
                </ng-container>
                <ng-template #load_else_isActiveCustomerDriver>
                    <em class="fas fa-times text-danger cursordisable"></em>
                </ng-template> 
                <span translate class="ml-2">lblIsActive</span>
                </label>
              </div>

            </div>
            <div class="p-3 " *ngIf="editDriver">
              <div class="row" >
                <div class="col-12 d-flex flex-sm-row flex-column justify-content-end ">
                  <button type="submit" class="btn btn-primary btn-lg mr-sm-2"
                          [disabled]="!editCustomerDriverForm.valid " translate
                          aria-label="Center Align">
                    lblUpdate
                  </button>
                  <a (click)="Cancelform('Driver')" class="btn btn-secondary btn-lg" translate>lblCancel</a>
                </div>
              </div>
            </div>
          </form>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="ServiceContract" *ngIf="customerDetails && customerDetails.serviceContractCustomer">
        <ng-template ngbPanelHeader class="custom-header ctm">
          <div class="d-flex align-items-center">
            <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center text-left py-1-5" aria-label="Center Align">
              lblServiceContract
              <div class="ml-auto">
                <ng-container *ngIf="!acc.activeIds.includes('servicecontract')"><em class="fas fa-angle-down fa-lg ml-auto"></em>
                </ng-container>
                <ng-container *ngIf="acc.activeIds.includes('servicecontract')"><em class="fas fa-angle-up fa-lg ml-auto"></em>
                </ng-container>
              </div>
            </button>

          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width:30px" scope="col" translate class="">lblCustomerNumber</th>
                <th style="width:30px" scope="col" translate>lblCustomerName</th>
                <th style="width:30px" scope="col" translate>lblContractStartDate</th>
                <th style="width:30px" scope="col" translate>lblContractExpiryDate</th>
                <th style="width:30px" scope="col" translate>lblStatus</th>
                <th style="width:30px" scope="col" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="customerDetails.serviceContractCustomer?.length>0; else load_else">
                <tr *ngFor="let customer of customerDetails.serviceContractCustomer; let i=index">
                  <td>
                    {{customer.customerNo}}
                  </td>
                  <td>
                    {{customer.customerName}}
                  </td>
                  <td>
                    <div class="lbl-info" *ngIf="customer.startDate else elsevehicleContractStartDate">
                      {{ customer.startDate | date:'shortDate'}}
                    </div>
                    <ng-template class="lbl-info" #elsevehicleContractStartDate>
                      NA
                    </ng-template>
                  </td>
                  <td>
                    <div class="lbl-info" *ngIf="customer.expiredDate else elsevehicleContractStartDate">
                      {{ customer.expiredDate | date:'shortDate'}}
                    </div>
                    <ng-template class="lbl-info" #elsevehicleContractStartDate>
                      NA
                    </ng-template>
                  </td>
                  <td>
                    <div *ngIf="customer.expiredDate >= currentDate else elseStatus">
                      <div class="lbl-info" translate>lblActive</div>
                    </div>
                    <ng-template #elseStatus>
                      <div class="lbl-info" translate>lblInactive</div>
                    </ng-template>
                  </td>
                  <td>
                    <a class="btn btn-ico" (click)="viewCustomer(customer)"
                      ngbTooltip="{{'lblView' | translate}}">
                      <em class="far fa-eye fa-lg"></em>
                    </a>
                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="12" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
  <div class="p-3 bg-light pp-footer-top-brdr">
    <div class="row">
      <div class="col-4">
      </div>
      <div class="col-8 d-flex flex-sm-row flex-column justify-content-end ">
        <button type="button" class="add-button btn btn-primary btn-lg mr-3"
        (click)="UpdateVehicleCustomerMapping(false)"
        translate>
        <em class="far fa-save font16 align-top mr-2"></em>lblSave</button>
        <button type="button" class="add-button btn btn-primary btn-lg mr-3"
        (click)="UpdateVehicleCustomerMapping(true)"
        translate>
        <em class="far fa-save font16 align-top mr-2"></em>lblSaveAndClose</button>
      <ng-container>
        <button type="button" class="add-button btn btn-secondary btn-lg" (click)="OnClose()"
        translate>
        <em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</button>
      </ng-container>

      </div>
    </div>
  </div>
</div>

<ng-template #customerDuplication let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblExistingCustomerList</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
            (click)="modal.dismiss(false)">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="card pad15">
            <div class="row mt-2" *ngIf="duplicateCustomerList && duplicateCustomerList.length>0">
                <span translate>lblExistingCustomerLists</span>
                    <table>
                        <thead>
                            <tr>
                                <th translate>lblName</th>
                                <th translate>lblCustomerNumber</th>
                                <th translate>lblMatchingType</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let customer of duplicateCustomerList">
                                <td>
                                    <label translate class="ml-2">
                                        {{customer.customerName}}
                                    </label>
                                </td>
                                <td>
                                    <label translate class="ml-2">
                                        {{customer.customerNumber}}
                                    </label>
                                </td>
                                <td>
                                    <label translate class="ml-2">
                                        {{customer.matchType}}
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="d-flex flex-sm-row flex-column justify-content-end">
            <button type="submit" class="btn btn-primary mr-sm-2" translate
                aria-label="Center Align" (click)="modal.dismiss(true)">lblUpdate</button>
            <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </div>
</ng-template>